import { getFilterMiddlewareParams, normalizeFilterValueByItem } from '@intelligence/v3/filterControls/apiParams';
import { getFilterControlAdapter } from '@intelligence/v3/filterControls/controlAdapters';
import { replaceCurrentSearchParams } from '@intelligence/v3/utils/urlSearchParams';
import { getManagedFilterUrlKeys } from '../utils/managedUrlKeys';

import type { IFilterSyncTarget } from '../types';

const FILTER_SHORT_ID_QUERY_KEY = 'filter_short_id';
export const urlParamsSyncTarget: IFilterSyncTarget = {
  name: 'urlParams',
  shouldSync: (context) => {
    return !!context.pageId;
  },
  /** 将当前 confirmed value 写入明文 URL 参数，并清理短链参数 */
  sync: (values, context) => {
    const query: IRecord<string> = {};
    const managedUrlKeys = getManagedFilterUrlKeys(context?.items || []);

    context?.items?.forEach((item) => {
      const controlAdapter = getFilterControlAdapter(item?.type);

      if (!controlAdapter) {
        return;
      }

      const middlewareParams = getFilterMiddlewareParams(item);
      const normalizedValue = normalizeFilterValueByItem(item, values[item?.field]);
      const serialized = controlAdapter.middlewareUtils.serializeUrlParams(item, normalizedValue, middlewareParams);

      if (serialized) {
        Object.assign(query, serialized);
      }
    });

    const deleteQuery = Array.from(
      new Set([
        FILTER_SHORT_ID_QUERY_KEY,
        ...managedUrlKeys.filter((key) => !Object.prototype.hasOwnProperty.call(query, key)),
      ]),
    );
    replaceCurrentSearchParams(query, deleteQuery);
  },
};
